import { render } from "./IncomeDetail.vue?vue&type=template&id=73b0dc38&scoped=true"
import script from "./IncomeDetail.vue?vue&type=script&lang=js"
export * from "./IncomeDetail.vue?vue&type=script&lang=js"

import "./IncomeDetail.vue?vue&type=style&index=0&id=73b0dc38&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b0dc38"]])

export default __exports__